import(/* webpackMode: "eager" */ "/usr/src/app/src/app/[locale]/(digitalHub)/error.tsx");
